export const Loader = Object.freeze({
    status:
        {
            none: 'Loader.status.none',
            wait: 'Loader.status.wait',
        }
});